/**
 * QnA 카테고리 정의 — 관리자(QnAList)와 고객(QnA) 페이지가 공유.
 * 백엔드는 Board.inquiryType (자유 문자열) 필드에 value 를 저장합니다.
 * 향후 카테고리 추가 시 이 배열만 수정하면 양쪽 페이지에 동시 반영됩니다.
 */

export const QNA_CATEGORIES = [
  {
    value: 'feature',
    label: '기능',
    // 배지 색상 (옅은 배경 + 진한 텍스트)
    bg: '#EFF6FF',
    color: '#1D4ED8'
  },
  {
    value: 'support',
    label: '설치/기술지원',
    bg: '#ECFDF5',
    color: '#047857'
  },
  {
    value: 'billing',
    label: '결제/해지',
    bg: '#FEF3C7',
    color: '#92400E'
  }
];

// value → meta 조회 헬퍼
export const getQnACategory = (value) => {
  return QNA_CATEGORIES.find(c => c.value === value) || null;
};

// 카테고리가 비어있거나 알 수 없을 때 노출할 기본 라벨
export const QNA_CATEGORY_FALLBACK_LABEL = '미분류';

// 등록 폼 기본 카테고리(첫 항목)
export const QNA_DEFAULT_CATEGORY = QNA_CATEGORIES[0].value;
